var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "percent-bar-root",
      class: [_vm.$i18n.locale === "ar" ? "ar-style" : "", _vm.packageName],
    },
    [
      _c("div", { staticClass: "bar-container" }, [
        _c(
          "div",
          {
            staticClass: "bar-main",
            style: { width: _vm.barData.barMainWidth },
          },
          [
            _c(
              "div",
              {
                staticClass: "bar-progress",
                style: { width: `${_vm.barData.barPercent}%` },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "bar-tips-progress",
                    style: {
                      transform:
                        _vm.barData.barPercent >= 90
                          ? "translateX(-50%)"
                          : "translateX(0%)",
                    },
                  },
                  [
                    _c("img", {
                      style: {
                        left: _vm.barData.barPercent === 0 ? "-5px" : "10px",
                      },
                      attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                    }),
                    _vm._v(
                      " " + _vm._s(_vm.thousandthDigit(_vm.percentCount)) + " "
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _c("div", { staticClass: "bar-step0" }, [
          _c("div", { staticClass: "tips-root" }, [
            _c("div", { staticClass: "bar-tips0" }, [
              _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
              _c("span", [_vm._v(_vm._s(_vm.barData.tips0))]),
            ]),
          ]),
        ]),
        _vm.barData.step1Show
          ? _c("div", { staticClass: "bar-step1" }, [
              _c("div", { staticClass: "tips-root" }, [
                _c("div", { staticClass: "bar-tips1" }, [
                  _c("img", {
                    attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.barData.tips1))]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm.barData.step2Show
          ? _c("div", { staticClass: "bar-step2" })
          : _vm._e(),
        _c("div", { staticClass: "bar-step3" }, [
          _c("div", { staticClass: "tips-root" }, [
            _c("div", { staticClass: "bar-tips3" }, [
              _vm.barData.icon3
                ? _c("img", {
                    attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                  })
                : _vm._e(),
              _c("span", [_vm._v(_vm._s(_vm.barData.tips3))]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }